import { types } from '@actions/organizations';
import { combineReducers } from 'redux';
import moment from 'moment';
import { personFieldTypes } from '@actions/conference';
import { PERSON_TYPES } from '@config/authentication';

export const initialState = {
  list: {
    isFetching: false,
    data: [],
    filter: {
      name: '',
      limit: 10,
      offset: 0,
      currentPage: 1,
      totalPages: 1,
    },
  },
  editForm: {
    id: null,
    name: '',
    company: '',
    rules: [],
    country: '',
    lang: '',
    isActive: false,
    edited: false,
    isSubmitting: false,
    users: [],
    attendees: [],
    introMessageId: null,
  },
  analystsFullList: {
    isFetching: false,
    isSubmitting: false,
    data: [],
  },
  allRules: [],
};

export const defaultClient = {
  name: '',
  type: PERSON_TYPES.CLIENT,
  phoneNumber: '',
  country: '',
  timezone: moment().format('Z'),
  email: '',
};

export default combineReducers({
  list: (state = initialState.list, action = {}) => {
    switch (action.type) {
      case types.LOAD_ORGANIZATIONS.REQUEST:
        return {
          ...state,
          isFetching: true,
        };
      case types.LOAD_ORGANIZATIONS.SUCCESS:
        const {
          data,
          meta: { currentPage, totalPageCount },
        } = action.payload;

        return {
          ...state,
          isFetching: false,
          data,
          filter: {
            ...state.filter,
            currentPage,
            totalPages: totalPageCount,
          },
        };
      case types.LOAD_ORGANIZATIONS.FAILURE:
        return {
          ...initialState.list,
        };
      case types.UPDATE_ORGANIZATION.SUCCESS:
        return {
          ...state,
          data: [
            ...state.data.map((item) => {
              if (item.id === action.payload.id) {
                return { ...item, ...action.payload };
              }
              return item;
            }),
          ],
        };
      case types.FILTER.SET:
        return {
          ...state,
          filter: {
            ...state.filter,
            ...action.payload,
          },
        };
      case types.FILTER.CLEAR:
        return {
          ...initialState.list,
        };

      default:
        return state;
    }
  },
  analystsFullList: (state = initialState.analystsFullList, action = {}) => {
    switch (action.type) {
      case types.LOAD_ANALYSTS_LIST.REQUEST:
        return {
          ...state,
          isFetching: true,
        };
      case types.LOAD_ANALYSTS_LIST.SUCCESS:
        return {
          ...state,
          isFetching: false,
          data: action.payload,
        };
      case types.LOAD_ANALYSTS_LIST.FAILURE:
        return initialState.analystsFullList;
      case types.UPDATE_ORGANIZATION.SUCCESS:
        return {
          ...state,
          data: [
            ...state.data.map((item) => {
              if (item.id === action.payload.id) {
                return { ...item, ...action.payload };
              }
              return item;
            }),
          ],
        };
      case types.LOAD_ANALYSTS_LIST.SET_FILTER:
        return {
          ...state,
          keyWord: action.payload,
        };
      case types.LOAD_ANALYSTS_LIST.SET_FILTER:
        return {
          ...state,
          keyWord: '',
        };

      default:
        return state;
    }
  },
  editForm: (state = initialState.editForm, action = {}) => {
    switch (action.type) {
      case types.UPDATE_ORGANIZATION.FIELD:
        return {
          ...state,
          edited: true,
          ...action.payload,
        };
      case types.UPDATE_ORGANIZATION.REQUEST:
        return {
          ...state,
          isSubmitting: true,
        };
      case types.UPDATE_ORGANIZATION.SUCCESS:
        return {
          ...state,
          isSubmitting: false,
        };
      case types.UPDATE_ORGANIZATION.FAILURE:
        return {
          ...state,
          isSubmitting: false,
        };
      case types.UPDATE_ORGANIZATION.STARTED:
        return {
          ...initialState.editForm,
          ...action.payload,
          isSubmitting: false,
        };
      case types.UPDATE_ORGANIZATION.END:
        return {
          ...initialState.editForm,
        };
      case types.CREATE_ORGANIZATION.WINDOW_OPEN:
        return {
          ...initialState.editForm,
        };
      case types.CREATE_ORGANIZATION.WINDOW_CLOSE:
        return {
          ...initialState.editForm,
        };
      case types.CREATE_ORGANIZATION.REQUEST:
        return {
          ...state,
          isSubmitting: true,
        };
      case types.CREATE_ORGANIZATION.SUCCESS:
        return {
          ...state,
          isSubmitting: false,
        };
      case types.CREATE_ORGANIZATION.FAILURE:
        return {
          ...state,
          isSubmitting: false,
        };
      case types.ADD_ATTENDEE:
        return {
          ...state,
          attendees: [...state.attendees, { ...defaultClient }],
        };
      case types.REMOVE_ATTENDEE:
        return {
          ...state,
          attendees: state.attendees.filter((attendee, id) => id !== action.id),
        };
      case types.UPDATE_ORGANIZATION.ATTENDEE:
        if (!Object.values(personFieldTypes).includes(action.field)) return state;
        return {
          ...state,
          attendees: state.attendees.map((attendee, i) => {
            return i === action.id
              ? { ...attendee, [action.field]: action.value }
              : attendee;
          }),
        };
      default:
        return state;
    }
  },
  allRules: (state = initialState.allRules, action = {}) => {
    switch (action.type) {
      case types.LOAD_RULES.REQUEST:
        return initialState.allRules;

      case types.LOAD_RULES.SUCCESS:
        return action.payload;

      case types.LOAD_RULES.FAILURE:
        return initialState.allRules;

      default:
        return state;
    }
  },
});



// WEBPACK FOOTER //
// ./redux/reducers/organizations.js